// delegated-resume-pause-owner-guard.ts — security F-04 + N-1 (06k review).
//
// Phiên chat không được gỡ pause của NGƯỜI mà không qua người. "Pause người còn
// hiệu lực" = có `mission_pause_applied` với `directive_source` ≠ `chat_delegated`
// (sự kiện cũ thiếu field ⇒ coi như người — fail-closed) mà CHƯA có
// `mission_resume_applied` nào sau nó. Pause ủy nhiệm chồng lên KHÔNG xoá cờ
// (N-1: pause người → pause --delegated → resume --delegated không được lách).
// Kiểm 2 nơi: CLI lúc ghi directive (`delegatedResumeRejection`, thêm cả pause
// người còn nằm trong inbox) và supervisor lúc áp (`humanPauseInForce`).
import { join } from "node:path";
import { CHAT_DELEGATED_SOURCE } from "./chat-delegated-attribution.js";
import {
  isDirectiveProcessed,
  listInboxDirectiveIds,
  readInboxDirectiveRaw,
} from "./directive-inbox.js";
import { scanJournal } from "./journal-scan-report.js";
import { MISSION_JOURNAL_FILE_NAME } from "./mission-store.js";

export const HUMAN_PAUSE_RESUME_REFUSAL =
  "Pause đang hiệu lực do người áp (không phải Claude ủy nhiệm) — chỉ người gỡ: chạy " +
  "`avatar autopilot resume` từ terminal ngoài Claude Code.";
export const QUEUED_HUMAN_PAUSE_RESUME_REFUSAL =
  "Inbox còn directive pause của người chưa áp — chỉ người gỡ: chạy " +
  "`avatar autopilot resume` từ terminal ngoài Claude Code.";

/** Journal: còn pause của người chưa được resume nào gỡ? */
export async function humanPauseInForce(controlRoot: string): Promise<boolean> {
  const scan = await scanJournal(join(controlRoot, MISSION_JOURNAL_FILE_NAME));
  let inForce = false;
  for (const { delta } of scan.records) {
    if (delta.kind === "mission_resume_applied") inForce = false;
    else if (delta.kind === "mission_pause_applied") {
      if (delta.directive_source !== CHAT_DELEGATED_SOURCE) inForce = true;
    }
  }
  return inForce;
}

/** Inbox: còn directive `pause` không phải chat_delegated chưa xử lý? (JSON hỏng ⇒ bỏ qua: supervisor từ chối nó.) */
export async function queuedHumanPause(controlRoot: string): Promise<boolean> {
  for (const directiveId of await listInboxDirectiveIds(controlRoot)) {
    if (await isDirectiveProcessed(controlRoot, directiveId)) continue;
    const raw = (await readInboxDirectiveRaw(controlRoot, directiveId)) as Record<
      string,
      unknown
    > | null;
    if (raw?.kind === "pause" && raw.source !== CHAT_DELEGATED_SOURCE) return true;
  }
  return false;
}

export async function delegatedResumeRejection(controlRoot: string): Promise<string | undefined> {
  if (await humanPauseInForce(controlRoot)) return HUMAN_PAUSE_RESUME_REFUSAL;
  if (await queuedHumanPause(controlRoot)) return QUEUED_HUMAN_PAUSE_RESUME_REFUSAL;
  return undefined;
}
